import { render, staticRenderFns } from "./OsPreview.vue?vue&type=template&id=977d6e6e"
import script from "./OsPreview.vue?vue&type=script&lang=js"
export * from "./OsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports